import { InputBoX, MenuOption } from "../../../../common/dataClass/Default";
import { UserInfo } from "../../../../common/dataClass/User";

/**账户设置 */
class Account extends UserInfo{
  constructor() {
    super()
    /**联系公司 */
    this.companyName = ''
    /**公司联系人 */
    this.contactName = ''
    /**密码 */
    this.password = ''
    /**新密码 */
    this.newPassword = ''
    /**再次确认新密码 */
    this.againPassword = ''
    /**新邮箱 */
    this.newEmail = ''
  }
  /**修改基本信息请求体 */
  get getChangeUserInfoAxios(){
    let obj = {
      'companyName': this.companyName,
      'contactName': this.contactName,
    }
    return obj
  }
  /**修改密码请求体 */
  get getChangePasswordAxios(){
    let obj = {
      'originalPassword': this.password,
      'newPassword': this.newPassword,
      'newPasswordConfirm': this.againPassword
    }
    return obj
  }
  /**修改邮箱请求体 */
  get getChangeEmailAxios(){
    let obj = {
      'password': this.password,
      'email': this.newEmail,
    }
    return obj
  }
}

/**账户设置输入类 */
class AcountInputBox extends InputBoX{
  constructor(type, name, data, obj = { pla: '', isDisable: false }) {
    super(type, name, data, obj)
  }
}

/**账户设置菜单类 */
class AccountMenuOption extends MenuOption{
  constructor(name, id) {
    super(name, id)
  }
}

class AccountNewModule{
  /**菜单 */
  static NEWMENU(){
    let arr = [
      new AccountMenuOption('基本信息', 'basicInfo'),
      new AccountMenuOption('修改密码', 'password'),
      new AccountMenuOption('修改邮箱', 'email'),
      new AccountMenuOption('开票信息', 'invoice')
    ]
    return arr
  }
  /**基本信息 */
  static NEWBASICINFO(){
    let arr = [
      new AcountInputBox('text', '账户ID', 'id', { isDisable: true }),
      new AcountInputBox('text', '注册手机', 'phone', { isDisable: true }),
      new AcountInputBox('text', '注册邮箱', 'email', { isDisable: true }),
      new AcountInputBox('text', '公司名称', 'companyName'),
      new AcountInputBox('text', '联系人', 'contactName'),
    ]
    return arr
  }
  /**修改密码 */
  static NEWPASSWORD(){
    let arr = [
      new AcountInputBox('password', '当前密码', 'password'),
      new AcountInputBox('password', '新的密码', 'newPassword'),
      new AcountInputBox('password', '确认密码', 'againPassword'),
    ]
    return arr
  }
  /**修改邮箱 */
  static NEWEMAIL(){
    let arr = [
      new AcountInputBox('password', '当前密码', 'password'),
      new AcountInputBox('text', '新的邮箱', 'newEmail'),
    ]
    return arr
  }
}

export { Account, AccountNewModule }
